import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sliderFilled"
const SliderFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.25 13.5C9.648 13.5 10.823 14.456 11.156 15.75H20.25V17.25H11.156C10.822 18.544 9.648 19.5 8.25 19.5S5.678 18.544 5.344 17.25H3.75V15.75H5.344C5.678 14.456 6.852 13.5 8.25 13.5M17.625 4.5C19.282 4.5 20.625 5.843 20.625 7.5S19.282 10.5 17.625 10.5C16.227 10.5 15.053 9.544 14.72 8.25H3.75V6.75H14.72C15.052 5.456 16.227 4.5 17.625 4.5" />
        </svg>
      }
    </span>
  )
}
export default SliderFilledIcon
